export default __webpack_public_path__ + "static/media/organization_size_pink.569c513d.png";